import React from 'react';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const CompanyIntroduction = () => {
  // This new data structure outlines the client's journey.
  const planningJourney = [
    {
      icon: 'PenTool',
      title: '1. Vision & Collaboration',
      description: 'Our journey begins with you. We listen to your story, understand your style, and collaboratively define a vision that is a true reflection of you as a couple.'
    },
    {
      icon: 'Palette',
      title: '2. Design & Curation',
      description: 'We translate your vision into a bespoke design concept, curating a team of elite vendors and orchestrating every aesthetic detail from florals to lighting.'
    },
    {
      icon: 'ShieldCheck',
      title: '3. Flawless Execution',
      description: 'With meticulous planning and seamless coordination, we manage every logistical complexity, allowing you to relax and be a guest at your own wedding.'
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-gradient-to-b from-card to-background">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          {/* Left Column: The Planning Journey */}
          <div>
            <h2 className="font-heading font-bold text-3xl lg:text-4xl text-foreground mb-6">
              Your Dream Wedding, Realized
            </h2>
            <p className="font-body text-lg text-muted-foreground mb-8">
              From the first sketch to the final farewell, we believe in a planning process that is as joyful and memorable as the day itself. This is our promise to you.
            </p>
            <div className="space-y-6">
              {planningJourney.map((step, index) => (
                <div key={index} className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-primary/10 text-primary rounded-lg flex items-center justify-center">
                    <Icon name={step.icon} size={24} />
                  </div>
                  <div>
                    <h3 className="font-heading font-semibold text-lg text-foreground mb-1">{step.title}</h3>
                    <p className="font-body text-muted-foreground">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
            <Button
              variant="default"
              size="lg"
              onClick={() => window.location.href = '/about'}
              iconName="ArrowRight"
              iconPosition="right"
              className="mt-10"
            >
              Learn More About Our Story
            </Button>
          </div>

          {/* --- THIS IS THE CHANGE --- */}
          {/* The 'src' attributes now point to your local images in the public/gallery folder. */}
          <div className="relative h-96 hidden lg:block">
            <Image
              src="/gallery/image-1.jpg" // Replaced with your image
              alt="Elegant event table setting with intricate details"
              className="absolute top-0 left-0 w-2/3 h-80 object-cover rounded-lg shadow-xl -rotate-3 transition-transform duration-500 hover:rotate-0 hover:scale-105"
            />
            <Image
              src="/gallery/image-2.jpg" // Replaced with your image
              alt="Joyful couple celebrating their special day"
              className="absolute bottom-0 right-0 w-3/4 h-72 object-cover rounded-lg shadow-2xl rotate-2 transition-transform duration-500 hover:rotate-0 hover:scale-105 z-10"
            />
          </div>

        </div>
      </div>
    </section>
  );
};

export default CompanyIntroduction;